import { all, call, put, takeEvery } from 'redux-saga/effects';

import { exportInputValuesProgressModalClose } from '@app/features/exportInputValues';
import { initializeSubscriptionData } from '@app/features/subscription/state';
import authService from '@app/libs/auth/authService';
import { signOutSuccess } from '@app/store/account/sign-out/actions';
import { ACCOUNT_SIGN_OUT_REQUEST } from '@app/store/actionTypes';
import { initializeUser, withAnalytics } from '@app/store/analytics/actions';
import { initializeEditingDocumentDomainData } from '@app/store/editingDocuments/actions';
import { initializeTemplatesData } from '@app/store/templates/actions';
import { initializeUserAuthority } from '@app/store/user/authority/actions';

export function* signOut() {
  yield call(authService.removeTokens);
  yield put(withAnalytics(initializeUser(), signOutSuccess()));
  yield put(initializeTemplatesData());
  yield put(initializeEditingDocumentDomainData());
  yield put(initializeSubscriptionData());
  yield put(initializeUserAuthority());
  yield put(exportInputValuesProgressModalClose());
}

export default function* saga() {
  yield all([takeEvery(ACCOUNT_SIGN_OUT_REQUEST, signOut)]);
}
